import { memo } from "react";

const TEXT_PATHS = `<path d="M17315 4608 l-50 -53 53 50 c28 27 52 51 52 52 0 8 -9 -1 -55 -49z"/>
<path d="M17460 4516 c0 -19 3 -37 8 -40 4 -2 6 13 4 35 -5 48 -12 51 -12 5z"/>
<path d="M4480 4179 c-319 -37 -598 -166 -805 -374 -177 -177 -288 -387 -347
-658 -19 -88 -22 -133 -23 -322 0 -246 9 -307 71 -495 136 -410 462 -681 924
-770 264 -51 592 -49 887 6 262 48 415 114 490 212 65 86 68 109 68 577 0 411
0 421 -22 467 -36 78 -71 116 -137 148 -95 46 -159 52 -502 48 -295 -3 -311
-4 -350 -25 -54 -29 -110 -93 -123 -140 -17 -62 -13 -182 8 -228 23 -51 80
-106 129 -124 24 -9 97 -15 204 -19 118 -3 171 -8 178 -17 7 -8 10 -66 8 -156
l-3 -143 -32 -22 c-54 -36 -150 -49 -368 -49 -193 0 -203 1 -288 29 -210 69
-347 217 -409 445 -18 63 -21 105 -22 246 0 201 12 263 80 404 85 174 227 284
424 330 229 53 396 32 715 -89 166 -62 319 -24 388 98 38 68 48 188 23 273
-41 143 -211 251 -496 314 -188 42 -473 56 -670 34z"/>
<path d="M15300 4179 c-110 -22 -209 -98 -256 -197 -24 -51 -26 -64 -21 -137
6 -91 9 -100 257 -765 415 -1116 469 -1254 514 -1324 63 -99 178 -177 311
-211 80 -20 291 -20 369 0 132 34 246 118 308 225 29 50 212 533 523 1380 220
598 219 594 219 705 1 90 -2 105 -27 152 -52 100 -188 175 -317 176 -164 0
-260 -77 -328 -263 -147 -402 -364 -993 -409 -1115 -31 -82 -66 -179 -78 -215
-70 -198 -84 -233 -89 -220 -102 288 -164 459 -240 664 -52 138 -151 403 -220
589 -69 186 -137 360 -151 386 -44 88 -125 150 -223 170 -60 12 -78 12 -142 0z"/>
<path d="M9871 4139 c-119 -21 -203 -86 -241 -187 -21 -56 -21 -62 -20 -1100
0 -657 4 -1061 11 -1089 14 -65 32 -96 84 -141 79 -70 200 -96 318 -68 37 9
81 23 97 31 48 25 98 84 122 144 21 52 22 76 27 371 l6 315 230 -3 c326 -5
494 14 652 74 250 94 418 293 479 569 23 104 23 346 1 457 -66 324 -300 548
-642 614 -76 15 -164 18 -580 20 -272 1 -514 -2 -544 -7z m827 -539 c88 -12
178 -50 220 -93 64 -66 91 -174 72 -291 -19 -119 -67 -183 -175 -233 -58 -26
-66 -27 -290 -33 -126 -3 -236 -4 -242 -2 -18 6 -19 632 -1 650 15 15 307 16
416 2z"/>
<path d="M8340 3940 c-98 -18 -154 -55 -197 -128 -27 -46 -28 -52 -33 -237
l-5 -190 -90 -6 c-97 -6 -134 -20 -176 -66 -52 -55 -64 -91 -63 -188 2 -179
67 -250 240 -262 l84 -6 2 -151 c1 -83 2 -252 3 -376 2 -268 14 -341 80 -477
56 -113 130 -186 250 -243 92 -44 148 -57 292 -70 194 -17 376 12 456 73 105
80 131 304 44 385 -45 42 -88 52 -219 49 -150 -3 -188 12 -226 85 -34 66 -41
148 -42 456 l0 272 133 0 c206 1 273 25 318 117 20 40 24 63 24 143 0 122 -25
179 -100 225 -47 29 -52 30 -209 35 l-161 5 -5 185 c-5 168 -7 189 -28 233
-44 88 -125 133 -262 142 -36 2 -85 0 -110 -5z"/>
<path d="M14095 3940 c-100 -16 -158 -53 -202 -128 -27 -46 -28 -52 -33 -237
l-5 -190 -90 -6 c-110 -7 -161 -31 -205 -97 -35 -52 -45 -109 -37 -205 12
-143 84 -205 246 -215 l90 -5 3 -416 c4 -403 4 -418 27 -486 102 -309 361
-443 801 -414 169 11 258 56 306 155 53 109 41 251 -26 308 -48 40 -92 49
-196 42 -153 -12 -215 18 -255 122 -20 53 -22 78 -27 373 l-5 317 159 4 c135
3 166 7 205 25 83 37 119 108 119 233 0 122 -33 190 -113 232 -37 20 -62 23
-202 28 l-160 5 -5 190 c-5 185 -6 191 -33 237 -32 56 -75 90 -137 111 -59 20
-162 27 -225 17z"/>
<path d="M19737 3940 c-109 -19 -181 -79 -214 -175 -13 -39 -17 -87 -18 -215
l0 -165 -80 -5 c-96 -7 -147 -30 -192 -88 -44 -57 -59 -135 -46 -230 19 -134
80 -187 230 -199 l80 -6 7 -139 c3 -76 4 -187 0 -246 -9 -167 10 -431 39 -529
45 -154 139 -267 282 -338 106 -52 192 -68 375 -67 159 0 222 9 297 42 l43 19
0 216 0 215 -27 11 c-17 6 -65 8 -125 3 -151 -10 -204 17 -244 128 -18 50 -27
352 -17 559 l6 127 151 4 c120 3 158 8 186 22 73 38 70 29 70 236 0 184 0 187
-24 209 -40 37 -107 51 -251 51 l-132 0 -5 188 c-4 169 -7 191 -27 232 -33 65
-68 97 -128 120 -63 23 -168 32 -236 20z"/>
<path d="M12523 3410 c-302 -33 -527 -162 -673 -385 -157 -242 -194 -615 -91
-919 72 -211 224 -378 434 -476 238 -112 609 -130 923 -46 171 46 255 100 291
183 20 50 17 176 -7 222 -57 114 -166 137 -358 77 -124 -39 -285 -61 -381 -52
-183 17 -298 105 -336 259 l-7 27 63 1 c35 1 267 2 515 3 l450 1 41 27 c66 44
78 80 78 243 -1 171 -22 262 -96 413 -103 210 -297 359 -529 405 -99 20 -228
27 -317 17z m234 -460 c31 -11 69 -32 84 -46 42 -41 90 -138 96 -197 l5 -52
-316 -1 -316 0 6 35 c17 92 68 181 126 223 82 58 213 74 315 38z"/>
<path d="M18232 3408 c-355 -23 -642 -223 -756 -527 -54 -143 -67 -209 -73
-371 -11 -327 68 -546 267 -733 134 -126 309 -203 528 -232 338 -45 735 30
853 162 48 53 62 99 57 187 -4 89 -35 144 -100 177 -74 38 -146 36 -278 -6
-264 -83 -496 -67 -623 44 -39 35 -84 118 -89 166 l-3 30 510 0 c455 0 513 2
540 16 72 40 95 95 95 226 -1 262 -82 480 -240 640 -169 171 -387 241 -688
221z m233 -462 c63 -30 99 -65 129 -124 24 -47 51 -151 42 -160 -3 -2 -147 -6
-321 -8 l-316 -4 7 38 c16 95 94 210 169 249 49 26 76 31 160 32 65 1 90 -4
130 -23z"/>
<path d="M6660 3395 c-186 -38 -334 -119 -457 -249 -115 -121 -196 -278 -227
-446 -21 -110 -21 -351 0 -461 35 -184 116 -333 254 -462 126 -119 306 -200
506 -228 137 -20 401 -17 504 5 334 70 443 150 442 324 -1 183 -149 266 -352
197 -298 -101 -568 -75 -680 66 -37 47 -77 140 -67 156 3 5 216 7 474 6 274
-2 490 1 521 7 69 12 110 42 134 98 17 37 20 66 19 161 -3 432 -250 752 -638
827 -94 18 -344 17 -433 -1z m364 -446 c96 -35 162 -129 182 -254 l6 -40 -317
-1 -317 -1 5 49 c8 62 60 161 106 199 83 69 226 89 335 48z"/>
<path d="M6660 3395 c-186 -38 -334 -119 -457 -249 -115 -121 -196 -278 -227
-446 -21 -110 -21 -351 0 -461 35 -184 116 -333 254 -462 126 -119 306 -200
506 -228 137 -20 401 -17 504 5 334 70 443 150 442 324 -1 183 -149 266 -352
197 -298 -101 -568 -75 -680 66 -37 47 -77 140 -67 156 3 5 216 7 474 6 274
-2 490 1 521 7 69 12 110 42 134 98 17 37 20 66 19 161 -3 432 -250 752 -638
827 -94 18 -344 17 -433 -1z m364 -446 c96 -35 162 -129 182 -254 l6 -40 -317
-1 -317 -1 5 49 c8 62 60 161 106 199 83 69 226 89 335 48z"/>`;

const TAGLINE_PATHS = `<path d="M20356 1209 c-10 -6 -38 -53 -62 -105 l-44 -93 -45 -7 c-33 -4 -51
-13 -62 -30 -21 -32 -11 -50 31 -58 20 -4 34 -11 31 -16 -16 -25 -65 -253 -65
-300 0 -66 28 -131 64 -155 69 -45 187 -22 263 50 38 37 44 48 41 76 -2 27 -8
35 -26 37 -13 2 -31 -3 -41 -12 -25 -23 -103 -56 -133 -56 -47 0 -61 34 -48
116 15 94 27 139 57 207 21 46 30 57 49 57 13 0 57 5 99 11 l75 11 0 39 c0 21
-5 41 -11 45 -6 3 -40 6 -75 5 l-64 -1 16 37 c9 21 22 57 30 80 11 37 11 45
-2 58 -18 17 -51 19 -78 4z"/>
<path d="M14768 1103 c-44 -51 -212 -582 -225 -709 l-6 -60 41 -32 c29 -23 39
-38 35 -52 -8 -31 39 -70 84 -70 95 0 262 126 326 248 37 68 45 145 20 191
-53 100 -157 96 -285 -10 -26 -21 -49 -39 -51 -39 -7 0 75 252 112 345 37 94
50 168 31 190 -17 20 -63 19 -82 -2z m169 -548 c18 -49 -83 -184 -171 -230
-44 -22 -106 -34 -106 -20 0 17 39 78 88 139 78 98 172 153 189 111z"/>
<path d="M13285 1018 c-7 -19 -17 -47 -20 -64 -4 -16 -33 -114 -65 -219 -98
-321 -142 -493 -135 -525 8 -35 39 -60 76 -60 22 0 44 20 118 109 50 60 113
126 141 146 71 52 80 42 79 -88 -1 -88 1 -102 20 -120 31 -31 98 -27 129 8 29
35 28 49 -8 75 -30 21 -30 22 -30 122 0 111 -11 143 -62 173 -50 29 -91 14
-177 -68 -109 -104 -133 -124 -127 -107 38 112 149 465 161 510 12 48 13 65 3
97 -12 34 -17 38 -51 41 -34 3 -39 0 -52 -30z"/>
<path d="M12885 1003 c-16 -2 -99 -15 -183 -30 -175 -30 -205 -45 -200 -97 3
-29 6 -31 47 -34 25 -2 85 4 134 13 49 9 90 15 92 13 2 -2 -26 -104 -61 -228
-157 -548 -163 -581 -124 -620 23 -23 53 -26 69 -6 7 8 25 63 41 123 16 59 61
214 100 343 38 129 80 274 93 322 24 93 28 98 94 98 17 0 61 -7 98 -15 74 -18
101 -10 111 30 9 36 -19 72 -63 84 -36 10 -180 13 -248 4z"/>
<path d="M16305 984 c-19 -19 -55 -90 -80 -156 -16 -43 -21 -48 -54 -53 -67
-10 -116 -29 -119 -48 -6 -31 17 -47 69 -47 57 0 57 1 34 -105 -19 -89 -19
-215 -1 -259 18 -43 56 -72 106 -80 92 -14 195 73 176 149 -8 33 -27 32 -78
-5 -27 -20 -52 -30 -68 -28 l-25 3 1 105 c0 100 19 193 46 226 5 7 50 15 101
19 99 8 117 15 117 50 0 39 -30 55 -103 55 -37 0 -67 4 -67 10 0 5 9 32 20 60
23 58 25 91 8 108 -17 17 -64 15 -83 -4z"/>
<path d="M19865 951 c-54 -25 -108 -83 -143 -156 -40 -80 -52 -128 -52 -203 0
-116 50 -182 145 -190 74 -6 132 17 184 73 42 46 53 89 29 113 -19 19 -38 14
-75 -19 -20 -17 -51 -38 -70 -47 -31 -15 -37 -15 -60 -2 -30 17 -45 61 -37
107 l6 31 71 -5 c65 -4 78 -2 127 24 70 36 100 84 100 164 0 46 -4 61 -25 83
-46 49 -128 61 -200 27z m106 -91 c29 -16 23 -44 -16 -79 -27 -23 -45 -31 -75
-31 -21 0 -41 4 -44 9 -8 13 41 74 77 94 37 20 33 20 58 7z"/>
<path d="M19250 931 c-15 -28 -12 -211 5 -313 16 -98 35 -143 73 -176 l27 -22
-40 -76 c-22 -42 -57 -92 -79 -111 -35 -32 -42 -35 -85 -30 -25 3 -55 8 -67
12 -28 9 -54 -18 -54 -55 0 -62 116 -99 204 -66 62 24 145 115 194 212 22 43
69 153 105 244 36 91 77 190 91 220 45 96 26 183 -36 166 -35 -9 -62 -58 -113
-206 -26 -74 -51 -143 -56 -152 -29 -54 -49 17 -56 197 -6 157 -13 175 -69
175 -23 0 -37 -6 -44 -19z"/>
<path d="M18656 903 c-57 -17 -126 -82 -168 -159 -53 -98 -64 -274 -21 -331
71 -96 229 -87 317 18 32 38 42 74 26 94 -20 24 -47 17 -101 -25 -28 -22 -62
-43 -75 -46 -52 -13 -94 47 -80 114 7 27 7 27 79 24 89 -4 147 22 191 85 37
53 47 139 22 178 -33 51 -113 71 -190 48z m78 -99 c17 -6 21 -31 10 -59 -15
-39 -131 -70 -141 -38 -5 15 79 103 99 103 9 0 23 -3 32 -6z"/>
<path d="M18094 890 c-44 -17 -134 -315 -134 -441 0 -73 11 -94 56 -105 38
-10 58 16 79 102 16 65 26 85 69 131 62 69 121 109 198 136 73 27 86 42 67 83
-31 65 -143 34 -252 -68 -28 -26 -52 -47 -53 -45 -1 1 11 34 27 72 34 85 36
109 7 129 -25 18 -34 19 -64 6z"/>
<path d="M17583 843 c-108 -74 -242 -306 -243 -420 0 -45 4 -54 31 -77 63 -53
143 -29 258 79 l69 66 21 -44 c35 -72 126 -109 179 -71 35 24 23 94 -16 94
-30 0 -58 27 -72 70 -12 35 -11 50 3 113 23 95 22 98 -16 125 -17 12 -51 38
-75 57 -53 43 -85 44 -139 8z m101 -112 c17 -19 17 -22 -15 -80 -30 -58 -165
-201 -189 -201 -20 0 -9 40 33 122 39 78 120 178 144 178 5 0 18 -9 27 -19z"/>
<path d="M17062 833 c-47 -23 -120 -108 -153 -178 -36 -75 -63 -194 -56 -251
6 -60 46 -110 99 -125 81 -21 173 17 264 113 47 49 55 63 52 90 -2 25 -9 35
-30 42 -24 9 -33 4 -92 -51 -72 -68 -127 -93 -153 -72 -24 21 -12 124 24 201
30 65 84 128 108 128 20 0 27 -33 15 -64 -13 -36 -13 -42 6 -60 42 -42 97 2
110 89 16 112 -91 189 -194 138z"/>
<path d="M15821 808 c-64 -31 -166 -131 -195 -191 -33 -65 -35 -133 -5 -171
11 -15 47 -45 80 -67 84 -57 79 -69 -26 -69 -82 0 -85 -1 -91 -25 -12 -49 45
-85 134 -85 79 0 156 24 181 57 45 57 17 116 -92 197 -41 30 -77 62 -81 71
-15 40 75 149 156 188 43 21 48 5 17 -54 l-21 -43 22 -18 c33 -27 68 -22 101
13 52 56 51 149 -2 193 -40 34 -115 36 -178 4z"/>
<path d="M15315 751 c-112 -51 -215 -245 -202 -383 10 -110 60 -160 165 -166
61 -3 71 -1 121 30 63 39 98 90 87 131 -5 21 -12 27 -35 27 -15 0 -36 -9 -46
-20 -34 -37 -83 -61 -117 -58 -29 3 -35 9 -47 44 -8 23 -11 52 -7 67 6 26 8
27 84 27 54 0 89 6 119 19 74 34 124 144 100 220 -23 70 -136 101 -222 62z
m115 -96 c19 -23 3 -63 -33 -85 -30 -19 -117 -29 -117 -14 0 18 45 75 73 93
38 25 60 26 77 6z"/>
<path d="M13925 691 c-110 -50 -215 -256 -199 -391 12 -104 59 -156 152 -167
56 -6 115 15 170 62 63 53 76 119 26 131 -18 5 -35 -3 -69 -30 -61 -50 -98
-63 -129 -42 -26 17 -43 79 -31 116 6 19 12 21 60 15 68 -9 151 14 187 52 54
57 74 153 43 212 -29 58 -131 78 -210 42z m119 -107 c9 -24 -12 -62 -43 -79
-33 -17 -111 -21 -111 -5 0 15 72 91 94 100 26 9 53 2 60 -16z"/>`;
const PURPLE_PATHS = `<path d="M15008 4937 c-35 -28 -61 -91 -89 -214 -20 -88 -23 -124 -23 -358 0
-276 9 -345 42 -345 11 0 26 17 39 43 12 23 43 67 70 97 28 30 48 62 46 70 -3
10 -2 11 4 3 6 -9 24 -4 69 18 34 16 91 37 126 46 64 16 70 16 212 -6 80 -12
150 -19 157 -16 20 13 -1 58 -85 185 -96 146 -202 275 -313 381 -119 114 -198
144 -255 96z"/>
<path d="M17391 4929 c-62 -36 -165 -135 -267 -259 -129 -156 -260 -359 -250
-386 7 -19 46 -16 190 13 199 39 395 -50 501 -229 57 -97 67 -79 84 147 21
284 -24 613 -98 705 -39 49 -87 52 -160 9z m-21 -272 c0 -1 -24 -25 -52 -52
l-53 -50 50 53 c46 48 55 57 55 49z m102 -146 c2 -22 0 -37 -4 -35 -8 5 -11
74 -4 74 2 0 6 -18 8 -39z"/>
<path d="M935 4181 c-94 -24 -163 -87 -218 -198 -48 -96 -62 -160 -60 -288 1
-181 51 -321 150 -422 65 -67 119 -93 198 -93 144 0 255 108 314 306 42 143
22 367 -47 503 -33 66 -104 141 -160 170 -45 23 -132 34 -177 22z"/>
<path d="M1798 4056 c-138 -49 -255 -189 -320 -382 -20 -59 -23 -89 -23 -209
1 -160 17 -218 81 -294 54 -63 105 -85 189 -85 109 0 173 30 265 123 130 130
192 285 194 481 1 126 -16 191 -71 270 -53 75 -121 110 -212 110 -36 -1 -83
-7 -103 -14z"/>
<path d="M185 3532 c-208 -100 -247 -449 -78 -704 80 -121 215 -199 322 -184
111 15 187 80 233 196 32 81 32 269 1 359 -52 147 -144 266 -246 318 -70 35
-175 42 -232 15z"/>
<path d="M2324 3245 c-107 -34 -222 -116 -286 -205 -108 -149 -147 -341 -97
-474 24 -65 96 -136 157 -154 260 -78 581 220 584 543 1 104 -16 156 -69 215
-71 80 -183 109 -289 75z"/>
<path d="M1110 2956 c-99 -34 -142 -66 -305 -226 -82 -81 -188 -176 -235 -211
-47 -35 -104 -82 -127 -105 -234 -234 -209 -594 52 -715 116 -55 260 -61 413
-19 40 11 106 25 147 31 92 12 160 -3 286 -67 184 -92 318 -119 443 -90 201
47 316 197 316 412 0 147 -42 235 -194 409 -48 55 -108 133 -133 175 -151 248
-222 334 -317 382 -103 53 -237 62 -346 24z"/>`;

interface Props {
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

/**
 * Vector GetPetVet wordmark + paw + cat ears.
 * Wordmark uses currentColor so it inherits theme foreground.
 * Brand purple is fixed.
 */
const GetPetVetLogo = ({ className, style, title = "GetPetVet" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2054 496"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    aria-label={title}
    className={className}
    style={style}
  >
    <g
      transform="translate(0,496) scale(0.1,-0.1)"
      fill="currentColor"
      stroke="none"
      dangerouslySetInnerHTML={{ __html: TEXT_PATHS }}
    />
    <g
      transform="translate(0,496) scale(0.1,-0.1)"
      fill="#7c3aed"
      stroke="none"
      dangerouslySetInnerHTML={{ __html: PURPLE_PATHS }}
    />
    <g
      transform="translate(0,496) scale(0.1,-0.1)"
      fill="#7c3aed"
      stroke="none"
      dangerouslySetInnerHTML={{ __html: TAGLINE_PATHS }}
    />
  </svg>
);

export default memo(GetPetVetLogo);
